import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api-types'
import type { ReporterSiteConfig } from '../types'
import { SERVER_EVENTS_APP_DEF_ID } from '../constants'
import type { TPAPublicClientSpecEntry } from '@wix/thunderbolt-ssr-api'

const reporterSiteConfig: SiteConfigFn<ReporterSiteConfig> = ({ api }) => {
	// Get basic fields
	const userId = api.rendererModel.getUserId()
	const metaSiteId = api.rendererModel.getMetaSiteId()

	// Check if premium
	const premiumFeatures = api.rendererModel.getPremiumFeatures() || []
	const isPremium = premiumFeatures.length > 0

	// Check if FB Server Events App is provisioned
	const clientSpecMap = api.rendererModel.getClientSpecMap() || {}
	let isFBServerEventsAppProvisioned = false

	for (const app of Object.values(clientSpecMap)) {
		if (
			(app as TPAPublicClientSpecEntry).appDefinitionId === SERVER_EVENTS_APP_DEF_ID &&
			!(app as TPAPublicClientSpecEntry).permissions?.revoked
		) {
			isFBServerEventsAppProvisioned = true
			break
		}
	}

	// Get dynamic pages IDs from routers
	const routersConfig = api.rendererModel.getRouters()?.configMap || {}
	const dynamicPagesIds: string[] = []

	for (const router of Object.values(routersConfig)) {
		if (router.pages) {
			const pageIds = Object.values(router.pages)
			dynamicPagesIds.push(...pageIds)
		}
	}

	const siteConfig: ReporterSiteConfig = {
		userId,
		metaSiteId,
		isPremium,
		isFBServerEventsAppProvisioned,
		dynamicPagesIds,
	}

	return {
		shouldLoadSiteFeature: true,
		shouldLoadSiteConfig: true,
		siteConfig,
	}
}

const name = 'reporter'

export const config = { site: reporterSiteConfig, name }
